import { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function ResetPasswordConfirm() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const [newPassword, setNewPassword] = useState("");
  const [msg, setMsg] = useState("");
  const mainRef = useRef(null);

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, []);

  const handleSubmit = async () => {
    try {
      await axios.post("/api/auth/reset-confirm/", {
        token,
        new_password: newPassword,
      });

      setMsg(t("reset_confirm.success"));
      setTimeout(() => navigate("/login"), 2500);
    } catch {
      setMsg(t("reset_confirm.error"));
    }
  };

  return (
    <main
      ref={mainRef}
      role="main"
      tabIndex={-1}
      aria-label={t("reset_confirm.title")}
      className="max-w-md mx-auto mt-10 mb-12 bg-white/95 border border-white/80 shadow-xl rounded-3xl p-7 sm:p-9"
    >
      <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight mb-7 text-center text-[#245580]" id="reset-confirm-title">
        🔒 {t("reset_confirm.title")}
      </h2>

      <label htmlFor="new-password" className="sr-only">
        {t("reset_confirm.placeholder")}
      </label>
      <input
        id="new-password"
        type="password"
        placeholder={t("reset_confirm.placeholder")}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        className="w-full border border-slate-300 bg-white px-4 py-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#247BA8] mb-4"
        aria-describedby="reset-confirm-title"
      />

      <button
        onClick={handleSubmit}
        className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded-xl shadow-md transition"
        aria-label={t("reset_confirm.button")}
      >
        {t("reset_confirm.button")}
      </button>

      {msg && (
        <p className="mt-4 text-center text-sm" role="status" aria-live="polite">
          {msg}
        </p>
      )}
    </main>
  );
}
